import {
  REQUEST_REJECT_CLAIM,
  REQUEST_CLAIM_RECAP,
  SET_CLAIM_RECAP,
  REQUEST_OPEN_CLAIM,
  REQUEST_ASSIGNMENT,
  REQUEST_CORPOREAL_LAWYERS,
  SET_CORPOREAL_LAWYERS,
  REQUEST_OPEN_MIXED_CLAIM,
  SET_OPENED_CLAIM,
  REQUEST_UPDATE_VICTIM_INFO,
  REQUEST_UPDATE_BENEFICIARY_INFO,
  REQUEST_UPDATE_VEHICLE_INFO,
  REQUEST_VALIDATE_VICTIM,
  REQUEST_VALIDATE_VEHICLE,
  REQUEST_VALIDATE_PROVISION_INTERVENANT,
  RESET_STORE_CLAIM,
  REQUEST_ADD_CLAIM_NUMBER,
  REQUEST_GET_FEE_NOTES_BY_CLAIM_ID,
  REQUEST_SET_SAGIS_CLAIM,
  REQUEST_GET_SAGIS_CLAIM,
  REQUEST_VALIDATE_COMPLETION_CLAIM_MANAGER,
} from 'containers/RecapManagerPage/constants';
import { AssignPayload } from 'containers/RecapManagerPage/typings';

export const requestRejectClaim = (
  claimId: string,
  rejectionReasons: string[],
  otherRejectionReason: string,
  decisionDetails: { decidedBy: string; decidedAt: Date },
  successCallback: Function,
) => ({
  type: REQUEST_REJECT_CLAIM,
  claimId,
  rejectionReasons,
  otherRejectionReason,
  decisionDetails,
  successCallback,
});

export const requestClaimRecap = (claimId: number) => ({
  type: REQUEST_CLAIM_RECAP,
  claimId,
});

export const setClaimRecap = (claim: any) => ({
  type: SET_CLAIM_RECAP,
  claim,
});

export const requestOpenClaim = (
  claimDetails: any,
  claimId: number,
  successCallback: Function,
) => ({
  type: REQUEST_OPEN_CLAIM,
  claimDetails,
  claimId,
  successCallback,
});
export const requestOpenMixedClaim = (
  claimDetails: any,
  claimId: number,
  successCallback: Function,
) => ({
  type: REQUEST_OPEN_MIXED_CLAIM,
  claimDetails,
  claimId,
  successCallback,
});

export const requestAssigment = (
  payload: AssignPayload,
  successCallback: Function,
) => {
  return {
    type: REQUEST_ASSIGNMENT,
    payload,
    successCallback,
  };
};

export const requestCorporealLawyers = () => ({
  type: REQUEST_CORPOREAL_LAWYERS,
});

export const setCorporealLawyers = (payload: {}) => {
  return {
    type: SET_CORPOREAL_LAWYERS,
    payload,
  };
};
export const setOpenedClaim = (payload: any) => {
  return {
    type: SET_OPENED_CLAIM,
    payload,
  };
};
export const requestUpdateVictimInfo = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_UPDATE_VICTIM_INFO,
    payload,
    successCallback,
  };
};
export const requestUpdateBeneficiaryInfo = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_UPDATE_BENEFICIARY_INFO,
    payload,
    successCallback,
  };
};
export const requestUpdateVehicleInfo = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_UPDATE_VEHICLE_INFO,
    payload,
    successCallback,
  };
};
export const requestValidateVictim = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_VALIDATE_VICTIM,
    payload,
    successCallback,
  };
};
export const requestValidateVehicle = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_VALIDATE_VEHICLE,
    payload,
    successCallback,
  };
};

export const requestValidateProvisionIntervenant = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_VALIDATE_PROVISION_INTERVENANT,
    payload,
    successCallback,
  };
};

export const resetStoreClaim = () => {
  return {
    type: RESET_STORE_CLAIM,
  };
};

export const requestAddClaimNumber = (claimInfo: any) => ({
  type: REQUEST_ADD_CLAIM_NUMBER,
  claimInfo,
});

export const requestGetFeeNotesByClaimId = (claimId: number) => ({
  type: REQUEST_GET_FEE_NOTES_BY_CLAIM_ID,
  claimId,
});
export const requestGetSagisClaim = (claimNumber: string) => ({
  type: REQUEST_GET_SAGIS_CLAIM,
  claimNumber,
});

export const setSagisClaim = (payload: any) => ({
  type: REQUEST_SET_SAGIS_CLAIM,
  payload,
});

export const requestValidateCompletionClaimManager = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_VALIDATE_COMPLETION_CLAIM_MANAGER,
  payload,
  successCallBack,
});
